import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ZoomIn, ZoomOut, OpenInFull } from '@mui/icons-material';
import { useContainerWidth } from '@lendica/hooks';

interface ChartControlsProps {
    zoomControls: {
        handleZoomIn: (cursorX?: number, useRecentDate?: boolean) => void;
        handleZoomOut: (cursorX?: number, useRecentDate?: boolean) => void;
        canZoomIn: boolean;
        canZoomOut: boolean;
    };
    onExpandToggle: () => void;
}

export const ChartControls: React.FC<ChartControlsProps> = ({ zoomControls, onExpandToggle }) => {
    const { isNarrow } = useContainerWidth();

    return (
        <Box
            sx={{
                position: 'absolute',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                top: -8,
                right: -16,
            }}
        >
            {isNarrow ? null : (
                <Tooltip title="Expand" placement="top">
                    <IconButton size="small" sx={{ pb: 1 }} onClick={onExpandToggle}>
                        <OpenInFull fontSize="small" sx={{ fontSize: 14 }} />
                    </IconButton>
                </Tooltip>
            )}
            <Tooltip title="Zoom in" placement="top">
                <IconButton
                    size="small"
                    onClick={() => zoomControls.handleZoomIn(undefined, true)}
                    disabled={!zoomControls.canZoomIn}
                >
                    <ZoomIn fontSize="small" sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Zoom out" placement="top">
                <IconButton
                    size="small"
                    onClick={() => zoomControls.handleZoomOut(undefined, true)}
                    disabled={!zoomControls.canZoomOut}
                >
                    <ZoomOut fontSize="small" sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>
        </Box>
    )
};
